import React , {useEffect, useState}from "react";
import {getFields} from "../../../../../dialog/formfields";
import {IconButton, Menu, MenuItem} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MDBox from "../../../../../../components/MDBox";
import TabPageHeader from "../../header/tabpageheader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import GenericForm from "../../../../../dialog/genericform";
import DataTableConfig from "../../../../../Tables/DataTableConfig";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";
import tableData from "../../../../../tabledata";

const CAPKConfig = ({ selectedRowData }) => {
    const { capkConfigColumns } = tableData();
    const { capkConfigFields } = getFields();
    const [capkConfig, setCapkConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create CAPK Config");
    const api = useConfigApi();

    const handleClick = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create CAPK Config");

    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRowIndex(null);
    };

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveRowIndex(index);
    };

    const handleActionClick = (action: string, item) => {
        const row = capkConfig[activeRowIndex];
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogData(row);
            setDialogTitle("View CAPK Config");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit CAPK Config");
            setDialogData(row);
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete CAPK Config");
            setDialogData(row);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        console.log("Submitted data:", formData, dialogMode);
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        // Call your API here
        if (dialogMode === "create") {
            // Handle create logic here
            api.post(Endpoints.capkConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("CAPK config successfully created.");
                    fetchCAPKConfigs(); // Fetch the latest data after creation
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        } else if (dialogMode === "edit") {
            // console.log("Edited date:", formData, dialogMode);
            api.put(Endpoints.capkConfig.createOrUpdate, formData)
                .then(({data}) => {
                  toast.success("CAPK config successfully updated.");
                  // fetchCAPKConfigs(); // Fetch the latest data after editing
                  const updatedRow = data?.data ?? formData; // prefer backend echo
                  setCapkConfig(prevRows => {
                      return prevRows.map((row) =>
                        row?.slNo === updatedRow?.slNo ? { ...row, ...updatedRow } : row );
                      });
                    // no refetch; order preserved
                    })
                .catch((error) => {
                    toast.error("Internal error occurred while updating.");
                });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.slNo) {
            toast.error("Missing slNo for deletion.");
            return;
        }
        api.delete(Endpoints.capkConfig.deleteBySlNo(formData.slNo))
            .then(() => {
                toast.success(`CAPK config ${formData.slNo} successfully deleted.`);
                fetchCAPKConfigs();
            })
            .catch(() => {
                toast.error("Error deleting CAPK config.");
            });
    };

    useEffect(() => {
        fetchCAPKConfigs();
    },[]);

    const truncateValue = (value) => {
        if (typeof value === "string" && value.length > 20) {
            return value.slice(0, 20) + "...";
        }
        return value;
    };

    const fetchCAPKConfigs = () => {
        api.get(Endpoints.capkConfig.getByControlSlNo(selectedRowData.slNo))
            .then((response) => {
                const data = response?.data.data || [];
                const modifiedData = data.map((item, index) => {
                    const action = (
                        <>
                            <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                                <MoreHorizIcon />
                            </IconButton>
                        </>
                    );
                    // Truncate all string values > 20 chars except 'action'
                    const truncatedItem = Object.fromEntries(
                        Object.entries(item).map(([key, value]) => {
                            if (key === "action") return [key, value];
                            return [key, truncateValue(value)];
                        })
                    );
                    return { ...truncatedItem, action };
                });
                setCapkConfig(modifiedData);
            })
            .catch((error) => {
                toast.error("Error while fetching records.");
            });
    };

    return <>
        <MDBox
            sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <TabPageHeader
                title="CAPK Config"
                showButton={true}
                buttonLabel = "Add"
                onButtonClick={handleClick}

            />
        </MDBox>
        <MDBox sx={{
            px: 3,
            py: 2,
            bgcolor: "#fff",
            borderBottom: "1px solid #d3e3fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            overflowX: "auto",
            width: "100%",
        }}>


            <DataTableConfig
                table={{ columns : capkConfigColumns, rows : capkConfig }}
                showTotalEntries={true}
                isSorted={true}
                noEndBorder
                entriesPerPage={true}
                canSearch={true}
            />
        </MDBox>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
        >
            <MenuItem onClick={() => handleActionClick("View")}>
                <IconButton size="small">
                    <i className="material-icons">visibility</i>
                </IconButton>
                View
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Edit")}>
                <IconButton size="small">
                    <EditIcon fontSize="small" />
                </IconButton>
                Edit
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Delete")}>
                <IconButton size="small" color="error">
                    <DeleteIcon fontSize="small" />
                </IconButton>
                Delete
            </MenuItem>
        </Menu>
        <GenericForm
            open={isModalOpen}
            handleClose={closeModal}
            title={dialogTitle}
            fields={capkConfigFields}
            onSubmit={handleDialogSubmit}
            onDelete={handleDialogDelete}
            initialData={dialogData}
            mode={dialogMode}
            useDialog={true}
        />
    </>
};

CAPKConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default CAPKConfig;
